import { render } from "./TasksList.vue?vue&type=template&id=3b3b3769&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=3b3b3769&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b3b3769"

export default script